<template>
  <v-expansion-panel>
    <v-form ref="form" lazy-validation>
      <v-expansion-panel-header class="headline">{{ $tc('label.complemento_informacao', 1)}}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <metadados-container-layout
          :metadados-entidade="metadados"
          :ordenacao-campos="ordenacaoCampos"
          :layout-class="layoutClass"
          :input-layout="inputLayout"
          :somenteLeitura="true"
          :objeto="acao.complementoInformacoes ? JSON.parse(acao.complementoInformacoes.value) : {}"
          ref="container">
        </metadados-container-layout>
      </v-expansion-panel-content>
    </v-form>
  </v-expansion-panel>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { copyObject } from '../../../common/functions/helpers';
import MetadadosContainerLayout from '../../../shared-components/metadados/MetadadosContainerLayout';

export default {
  name: 'PagamentoComplementoInformacoes',
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
    acao: {
      type: Object,
      default: {},
    },
    metadados: {
      type: Object,
      default: {},
    },
  },
  computed: {
    ...mapGetters('metadados', [
      'getApuracaoMetadado',
    ]),
    getCampos() {
      return this.configuracao.passo3.listaDinamica
        .filter((campo) => campo.etapasFluxo && campo.etapasFluxo.length > 0
          && campo.etapasFluxo.indexOf('APURACAO') > -1);
    },
  },
  components: {
    MetadadosContainerLayout,
  },
  data() {
    return {
      apuracaoAcaoResource: this.$api.apuracaoAcaoEdicao(this.$resource),

      ordenacaoCampos: [],
      layoutClass: { wrap: true },
      inputLayout: {
        xs12: true,
        sm12: false,
        md12: false,
        sm6: true,
        md3: true,
        md4: false,
        md6: false,
        md9: false,
      },
    };
  },
  methods: {
    ...mapActions('metadados', [
      'setApuracaoMetadado',
    ]),
    setMetadados() {
      const camposDinamicos = {};
      if (this.metadados) {
        const campos = copyObject(this.metadados.mapaCamposDinamicos);
        this.getCampos.forEach((campo) => {
          if (campos[campo.label] && !campo.indHabilitaAprovacaoApuracao) {
            camposDinamicos[campo.label] = campos[campo.label];
          }
        });
        this.metadados.mapaCamposDinamicos = camposDinamicos;
      }
    },
  },
  mounted() {
    this.setMetadados();
    this.ordenacaoCampos = this.configuracao.passo7.listaComplementoInformacoes
      .sort((a, b) => a.ordenacao < b.ordenacao).map((c) => c.label);
  },
};
</script>
